import { render } from "./QualIssueSummary.vue?vue&type=template&id=588d51f2&scoped=true"
import script from "./QualIssueSummary.vue?vue&type=script&lang=js"
export * from "./QualIssueSummary.vue?vue&type=script&lang=js"

import "./QualIssueSummary.vue?vue&type=style&index=0&id=588d51f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588d51f2"]])

export default __exports__